/* eslint-env browser */
import 'babel-preset-es2017/polyfill';
import 'isomorphic-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import AppContextual from './AppContextual';

function getClientContainer(store) {
  return (
    <AppContextual contextual={store.contextual} />
  );
}

function initializeContextualClient() {
  const initialState = window.__INITIAL_STATE__; // eslint-disable-line no-underscore-dangle
  ReactDOM.render(getClientContainer(initialState),
    global.window.document.getElementById('app-tes-answers__contextual')
  );
}

if (global.document) {
  global.document.addEventListener('DOMContentLoaded', initializeContextualClient);
}
